import type { SVGProps } from "react";

export default function SolarDoubleAltArrowRightLinear(props: SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" {...props}><g fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5"><path d="M11 19L17 12L11 5"/><path d="M7 19L13 12L7 5"/></g></svg>
  );
}
